import { useEffect } from "react";
import { Datasets } from "../../components/Dataset/Dataset";
import LocalInferenceContent from "./LocalInferencePage";
import NavigationBar from "../../components/NavBar/NavBar";
import DatasetWorkspaceShell from "../../components/Dataset/DatasetWorkspaceShell";
import "../../styles/DatasetPage.css";
import "../../styles/org-buttons.css";
import "./PreLabelPage.css";
import { useDataContext, PreLabelProvider } from "../../utils/DataContext";

function ModelPage() {
  return (
    <PreLabelProvider>
      <ModelPageChild />
    </PreLabelProvider>
  );
}

function ModelPageChild() {
  const { fetchModelsList } = useDataContext();

  useEffect(() => {
    fetchModelsList();
  }, []);

  const CustomizedContent = LocalInferenceContent;

  return (
    <div>
      <NavigationBar />
      <DatasetWorkspaceShell mainClassName="model-page">
        <Datasets
          CustomizedContent={CustomizedContent}
          overviewTitle="Pre-Label"
          overviewDescription="Run pre-labeling or DINO embedding extraction against selected datasets."
        />
      </DatasetWorkspaceShell>
    </div>
  );
}


export default ModelPage;
